export const SEARCH_QUERY_PARAM = 'q';
export const LOADING_SCREEN_CREATIVE_ID = 'loading-state-semantic-inventory-search';
